module.exports = __webpack_public_path__ + "otp-image.33c2812b1232a0308882.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/otp-image.svg
// module id = ../../../../../src/assets/images/otp-image.svg
// module chunks = main